module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'menu-open': _vm.$root.menuOpen
    },
    attrs: {
      "id": "app"
    }
  }, [(this.$root.headerIsVisible) ? _c('MainHeader') : _vm._e(), _vm._v(" "), _c('router-view', {
    key: _vm.$route.path
  }), _vm._v(" "), _c('MainFooter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 364
// module chunks = 0